"use client";

import { FC } from "react";
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/react";
import { TextResources } from "@portal/assets/text/TextResources";
import UndesirableHoldings from "./undesirableHoldings";
import { IFundSustainabilityProps } from "./types";
import useMorningstarSecuritiesEsg from "@portal/hooks/useMorningstarSecuritiesEsg";
import PageSpinner from "@portal/components/molecules/v2/pageSpinner";
import SustainabilityOverview from "./overview";
import Typography from "@portal/components/atoms/v2/typography";
import RegularTabButton from "@portal/components/atoms/tabButton/regular";

const FundSustainability: FC<IFundSustainabilityProps> = ({ fund }) => {
  const { data: morningstarSecuritiesEsg, isLoading } = useMorningstarSecuritiesEsg(fund.isin);

  if (isLoading) {
    return <PageSpinner />;
  }

  if (!morningstarSecuritiesEsg) {
    return <Typography>{TextResources.FUND_DISTRIBUTION_NO_ESG_DATA}</Typography>;
  }

  return (
    <TabGroup defaultIndex={0}>
      <div className="flex justify-center my-4">
        <TabList className="flex flex-wrap mb-1 gap-4 justify-center">
          <Tab>
            {({ selected }) => (
              <RegularTabButton selected={selected} label={TextResources.FUND_DISTRIBUTION_SUSTAINABILITY_OVERVIEW_TITLE} />
            )}
          </Tab>
          <Tab>
            {({ selected }) => (
              <RegularTabButton selected={selected} label={TextResources.FUND_DISTRIBUTION_UNDESIRABLE_HOLDINGS_TITLE} />
            )}
          </Tab>
        </TabList>
      </div>
      <TabPanels>
        <TabPanel>
          <SustainabilityOverview morningstarSecuritiesEsg={morningstarSecuritiesEsg} fund={fund} />
        </TabPanel>
        <TabPanel>
          <UndesirableHoldings morningstarSecuritiesEsg={morningstarSecuritiesEsg} />
        </TabPanel>
      </TabPanels>
    </TabGroup>
  );
};

export default FundSustainability;
